export enum CookieManagementEnum {
    Essenciais = 1,
    Google = 2
}

export function getAllCookieManagementEnumSum(): number {
    var cookieManagementEnumValues = Object.values(CookieManagementEnum).map(Number);
    return cookieManagementEnumValues.reduce((total, current) => total + current, 0);
}
